import differenceInSeconds from 'date-fns/differenceInSeconds'
import parseISO from 'date-fns/parseISO'
import * as React from 'react'

import {useIsAutodetectTimeZone} from '../../../hooks/useIsAutodetectTimeZone'
import useTimeSelector from '../../../hooks/useTimeSelector'
import {displayDate, formatDuration, parseDateToObj} from '../../../utils/dateTimeUtils'

import type {Props} from './BuildTimeInfo.types'

function BuildTimeInfo({startDate, finishDate, elapsedSeconds, children}: Props) {
  const isAutodetectTimeZone = useIsAutodetectTimeZone()
  const duration = useTimeSelector(
    now =>
      elapsedSeconds ||
      (startDate != null
        ? differenceInSeconds(finishDate != null ? parseISO(finishDate) : now, parseISO(startDate))
        : 0),
  )
  if (startDate == null) {
    return null
  }

  const durationText =
    duration != null && duration > 0
      ? ` (${formatDuration(duration, {alwaysShowSeconds: true})})`
      : ''

  let dateText = displayDate(startDate, isAutodetectTimeZone, true)
  if (finishDate != null) {
    let showOnlyTime = false
    const parsedStartDate = parseDateToObj(startDate, isAutodetectTimeZone)
    const parsedFinishDate = parseDateToObj(finishDate, isAutodetectTimeZone)

    if (parsedStartDate.isSame(parsedFinishDate, 'day')) {
      showOnlyTime = true
    }

    const finishDateText = `${displayDate(finishDate, isAutodetectTimeZone, true, !showOnlyTime)}`
    dateText += ` — ${finishDateText}`
  }

  return (
    <tr>
      <th>{finishDate == null ? 'Started' : 'Time'}</th>
      <td>
        {dateText}
        {durationText}
        {children}
      </td>
    </tr>
  )
}

export default React.memo<Props>(BuildTimeInfo)
